import Color from 'color';
import { ref as $ref } from '@graphistry/falcor-json-graph';

import { opt } from './views';

export const LABEL_SETTINGS_SHOW_PROPERTIES_IDX = 5;

export function labels(view, options) {

    options = options.vizClientParams || {};

    return {
        labelsByType: { edge: {}, point: {} },
        labels: {
            id: 'labels',
            name: 'Labels',
            edge: [],
            point: [],
            timeZone: '',
            opacity: opt(options, 'labelOpacity', Number, 1),
            poiMax: opt(options, 'pointsOfInterestMax', Number, 7),
            enabled: opt(options, 'showLabels', Boolean, true),
            shortenLabels: opt(options, 'shortenLabels', Boolean, true),
            poiEnabled: opt(options, 'showPointsOfInterest', Boolean, true),
            poiLabelEnabled: opt(options, 'showPointsOfInterestLabel', Boolean, true),
            highlightEnabled: opt(options, 'showLabelOnHover', Boolean, true),
            propertiesEnabled: opt(options, 'showLabelPropertiesOnHover', Boolean, false),
            showActions: opt(options, 'showActions', Boolean, true),
            inspectorEnabled: opt(options, 'showInspector', Boolean, true),
            foreground: { color: new Color(options.labelColor || '#fff') },
            background: { color: new Color(options.labelBackground || '#2e2e2e').alpha('labelOpacity' in options ? Number(options.labelOpacity) : 0.3) },
            renderer: $ref(`${view}.scene.renderer`),
            encodings: $ref(`${view}.encodings`),
            settings: [$ref(`${view}.labels.options`)],
            selection: undefined,
            expander: $ref(`${view}.expander`),
            controls: [
                {
                    selected: false,
                    id: 'toggle-label-settings',
                    name: 'Label settings',
                    type: 'settings'
                }
            ],
            options: {
                id: 'label-options',
                name: '',
                length: 11, // Check constants above if changed
                ...[
                    {
                        id: 'text-color',
                        type: 'color',
                        name: 'Text Color',
                        value: $ref(`${view}.labels.foreground.color`)
                    },
                    {
                        id: 'background-color',
                        type: 'color',
                        name: 'Background Color',
                        value: $ref(`${view}.labels.background.color`)
                    },
                    {
                        id: 'show-labels',
                        type: 'bool',
                        name: 'Show Labels',
                        value: $ref(`${view}.labels.enabled`)
                    },
                    {
                        id: 'shorten-labels',
                        type: 'bool',
                        name: 'Shorten Labels',
                        value: $ref(`${view}.labels.shortenLabels`)
                    }, 
                    {
                        id: 'show-label-highlight',
                        type: 'bool',
                        name: 'Show on Hover',
                        value: $ref(`${view}.labels.highlightEnabled`)
                    },
                    {
                        id: 'show-properties',
                        type: 'bool',
                        name: 'Show Properties',
                        value: $ref(`${view}.labels.propertiesEnabled`)
                    },
                    {
                        id: 'show-inspector',
                        type: 'bool',
                        name: 'Show Inspector',
                        value: $ref(`${view}.labels.inspectorEnabled`)
                    },
                    {
                        id: 'show-actions',
                        type: 'bool',
                        name: 'Show Action Bars',
                        value: $ref(`${view}.labels.showActions`)
                    },
                    {
                        id: 'show-points-of-interest',
                        type: 'bool',
                        name: 'Show Points of Interest',
                        value: $ref(`${view}.labels.poiEnabled`)
                    },
                    {
                        id: 'show-points-of-interest-label',
                        type: 'bool',
                        name: 'Show Label on Points of Interest',
                        value: $ref(`${view}.labels.poiLabelEnabled`)
                    },
                    {
                        id: 'poi-max-count',
                        type: 'discrete',
                        name: 'Max Points of Interest',
                        props: {
                            min: 0,
                            max: 500,
                            step: 5,
                            scale: 'none'
                        },
                        value: $ref(`${view}.labels.poiMax`)
                    },
                ]
            }
        }
    };
}
